export const config = {
  apiKey: 'AIzaSyAbIzX4hvRoBT2-uBeNfVMeEzV5MiWhL_U',
  authDomain: 'docmine-meili.firebaseapp.com',
  databaseURL: 'https://docmine-meili.firebaseio.com',
  projectId: 'docmine-meili',
  storageBucket: 'docmine-meili.appspot.com',
  messagingSenderId: '1018595628401'
}



// WEBPACK FOOTER //
// ./src/firebase/config.ts